import React from 'react';
import BaseLayout from 'Components/Layout/BaseLayout';
import PackageBanner from '../../Assets/Icons/PackageBanner.png';
import Breedcumb from 'Components/Breedcumb/Breedcumb';
import { useQuery } from 'Utils/Functions';
import Text from '../../Components/Text/Text';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function Disclaimer() {
  const isHeaderShow = useQuery('remove');
  const location = useLocation();

  return (
    <BaseLayout
      removeFooterAndHeader={isHeaderShow}
      _class={
        'header-top-offset booking-process-header my-booking-details-page my-booking-main-page'
      }
    >
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_URL}${location.pathname}`}
        />
        <title>Unipath Disclaimer - Important Information & Terms</title>
        <meta
          name="keywords"
          content=""
        />
        <meta
          name="description"
          content="Read the Unipath disclaimer to understand our terms, policies, and limitations regarding pathology lab tests and diagnostic services. Learn more here."
        />
      </Helmet>
      <Breedcumb list={[{ text: 'Disclaimer' }]} />
      <section className="terms-and-condition-section tag-interchange">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="terms-and-condition-wrapper">
                <div className="heading-component">
                  <h1>Disclaimer:</h1>
                </div>
                <Text>
                  This website is owned and operated by UNIPATH. The content
                  provided on this site is intended solely as a resource to
                  assist individuals in obtaining healthcare information. It
                  does not constitute medical advice or serve as a substitute
                  for professional medical consultation. This site may include
                  links to other websites. All materials, including any linked
                  content, are provided "as is" without any express or implied
                  warranties, including but not limited to warranties of
                  merchantability or fitness for a particular purpose. We do not
                  guarantee that access to this website or its pages will be
                  uninterrupted or error-free. UNIPATH makes no representations
                  about the usefulness or results of the information on this
                  website. UNIPATH does not control or guarantee the accuracy,
                  relevance, timeliness, or completeness of content on linked
                  sites and disclaims any implied warranties or representations
                  regarding such content. Please refrain from sending questions
                  or comments about your medical condition through this website
                  or any provided email addresses. For any concerns regarding
                  this website, please email us at{' '}
                  <a href="mailto:info@unipath.in">info@unipath.in.</a>
                </Text>
              </div>
            </div>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
}

export default Disclaimer;
